// extracted by mini-css-extract-plugin
export var shape = "styles-module--shape--ec103";
export var shape1 = "styles-module--shape1--81884";
export var shape2 = "styles-module--shape2--d3aeb";
export var shape3 = "styles-module--shape3--22de6";
export var shape4 = "styles-module--shape4--01acf";